import api from "./api";

export async function getOrderTypes() {
    const res = await api.get("/orderTypes");
    return res.data.data;
}
